import { ComponentViewDispatcher, ScrollEvent } from './component-view-dispatcher'
import { ListingType } from '../../__generated__/fed-graphql-types'
import { TrackingContext } from '../../utils/tracking/tracking'
import type { TrackViewInteractionCallback } from '../../hooks/tracking/useTrackViewedInteraction.hook'
import { GridPosition100 } from '@at/track-types'

export function observeResultsScroll(
    trackingElementRef: HTMLDivElement,
    listingType: ListingType,
    trackInteraction: TrackViewInteractionCallback,
    trackingContext: TrackingContext
): void {
    if (trackingElementRef) {
        const observer = new IntersectionObserver(
            ([intersectionObserverEntry]) => {
                const scrollEvent = new ScrollEvent(listingType, trackingContext)
                if (intersectionObserverEntry.isIntersecting) {
                    ComponentViewDispatcher.componentIsFullyVisible(scrollEvent, trackInteraction)
                }
            },
            {
                root: null,
                rootMargin: '0px',
                threshold: 1.0,
            }
        )
        observer.observe(trackingElementRef)
    }
}

const componentViewFired: Record<string, boolean> = {}

export function trackComponentViewedOnce(
    targetElt: HTMLDivElement,
    track: TrackViewInteractionCallback,
    componentNameLabel: string,
    gridPositionEntity?: GridPosition100
): void {
    if (targetElt && !componentViewFired[componentNameLabel]) {
        const intersectionObserver = new IntersectionObserver(
            ([intersectionObserverEntry], observer) => {
                if (intersectionObserverEntry.isIntersecting && !componentViewFired[componentNameLabel]) {
                    componentViewFired[componentNameLabel] = true
                    track(gridPositionEntity ? { additionalEntities: [gridPositionEntity] } : undefined)
                    observer.disconnect()
                }
            },
            {
                root: null,
                rootMargin: '0px',
                threshold: 1.0,
            }
        )
        intersectionObserver.observe(targetElt)
    }
}
